var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartWire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 471,
    height: 378,
    viewBox: "0 0 471 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2133_425)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 463,
    height: 370,
    rx: 24,
    fill: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2133_425",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 24,
    width: 389,
    height: 322
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.715 47.643L34.0292 192.163C22.0827 213.3 28.3906 240.068 48.5185 253.645L173.634 338.043C184.345 345.267 197.575 347.715 210.162 344.799L379.853 305.494C400.922 300.614 415.852 281.863 415.89 260.237L416.139 117.611C416.177 95.7345 400.974 76.7845 379.608 72.0796L166.238 25.0921C146.272 20.6958 125.776 29.8446 115.715 47.643Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2133_425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.357 104.535L312.047 78.2078L312.049 78.2186C305.286 74.1908 295.883 74.696 285.481 80.7015C282.084 82.6624 278.798 85.1008 275.672 87.8894L257.416 77.3402L257.419 77.3448C247.389 70.2936 232.87 70.6008 216.713 79.9292C196.274 91.7298 178.46 114.941 169.036 139.533C165.912 139.632 162.435 140.66 158.75 142.788C145.412 150.489 134.599 169.216 134.599 184.618C134.599 184.949 134.631 185.253 134.642 185.576C130.837 185.838 126.634 187.183 122.21 189.737C105.15 199.586 91.3213 223.539 91.3213 243.238C91.3213 253.001 94.7256 259.874 100.227 263.137L100.214 263.144L100.355 263.225C100.364 263.231 100.373 263.236 100.383 263.242L145.104 289.2L154.871 242.214L285.483 166.805C302.175 157.168 316.301 136.343 321.055 116.136L357.357 104.535Z",
    fill: "url(#paint0_linear_2133_425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5484 244.306C92.5484 224.608 106.377 200.655 123.437 190.804C127.861 188.251 132.064 186.906 135.869 186.643C135.86 186.319 135.826 186.017 135.826 185.685C135.826 170.284 146.638 151.556 159.977 143.855C163.661 141.729 167.139 140.701 170.264 140.602C179.687 116.01 197.501 92.7987 217.941 80.9981C234.097 71.6697 248.616 71.3625 258.646 78.4137L258.643 78.4091L276.899 88.9583C280.025 86.1682 283.311 83.7313 286.708 81.7704C297.11 75.7649 306.513 75.2597 313.276 79.2875L313.274 79.2767L356.965 104.662L357.355 104.538L312.046 78.211L312.048 78.2218C305.285 74.1941 295.881 74.6993 285.48 80.7063C282.082 82.6672 278.797 85.1056 275.671 87.8942L257.413 77.345L257.416 77.3496C247.386 70.2984 232.868 70.6055 216.711 79.9339C196.271 91.7345 178.457 114.946 169.034 139.537C165.909 139.637 162.431 140.664 158.747 142.793C145.409 150.493 134.596 169.222 134.596 184.622C134.596 184.954 134.628 185.257 134.639 185.581C130.834 185.843 126.631 187.188 122.207 189.742C105.148 199.591 91.3169 223.544 91.3169 243.243C91.3169 252.109 94.1438 258.56 98.7827 262.119C94.8886 258.4 92.5484 252.355 92.5484 244.306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.345 106.744C324.485 110.127 318.943 114.892 314.01 120.521C307.164 98.5306 286.283 91.7082 261.576 105.973C241.136 117.774 223.324 140.985 213.899 165.577C210.774 165.677 207.298 166.704 203.612 168.832C190.275 176.533 179.461 195.26 179.461 210.662C179.461 210.993 179.495 211.296 179.504 211.62C175.699 211.883 171.496 213.228 167.072 215.781C150.013 225.63 136.184 249.585 136.184 269.283C136.184 288.98 150.013 296.965 167.072 287.115L330.345 192.85C350.938 180.96 367.631 152.047 367.631 128.271C367.631 104.492 350.938 94.8545 330.345 106.744Z",
    fill: "url(#paint1_linear_2133_425)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M330.345 106.744C324.485 110.127 318.943 114.892 314.01 120.521C307.164 98.5306 286.283 91.7082 261.576 105.973C241.136 117.774 223.324 140.985 213.899 165.577C210.774 165.677 207.298 166.704 203.612 168.832C190.275 176.533 179.461 195.26 179.461 210.662C179.461 210.993 179.495 211.296 179.504 211.62C175.699 211.883 171.496 213.228 167.072 215.781C150.013 225.63 136.184 249.585 136.184 269.283C136.184 288.98 150.013 296.965 167.072 287.115L330.345 192.85C350.938 180.96 367.631 152.047 367.631 128.271C367.631 104.492 350.938 94.8545 330.345 106.744Z",
    fill: "url(#paint2_linear_2133_425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.345 106.744C324.485 110.127 318.943 114.892 314.01 120.521C307.164 98.5306 286.283 91.7082 261.576 105.973C241.136 117.774 223.324 140.985 213.899 165.577C210.774 165.677 207.298 166.704 203.612 168.832C190.275 176.533 179.461 195.26 179.461 210.662C179.461 210.993 179.495 211.296 179.504 211.62C175.699 211.883 171.496 213.228 167.072 215.781C150.013 225.63 136.184 249.585 136.184 269.283C136.184 288.98 150.013 296.965 167.072 287.115L330.345 192.85C350.938 180.96 367.631 152.047 367.631 128.271C367.631 104.492 350.938 94.8545 330.345 106.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M315.989 123.001C320.923 117.372 326.465 112.607 332.324 109.224C344.965 101.926 356.117 102.769 362.86 109.986C356.474 100.544 344.317 98.6782 330.347 106.744C324.783 109.957 319.523 114.442 314.781 119.703C315.214 120.768 315.631 121.853 315.989 123.001Z",
    fill: "url(#paint3_linear_2133_425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.553 286.498L248.78 262.116V243.39L206.553 267.77V286.498Z",
    fill: "url(#paint4_linear_2133_425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.553 267.77L248.78 243.39L206.553 219.011L164.326 243.39L206.553 267.77Z",
    fill: "url(#paint5_linear_2133_425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.326 262.116L206.553 286.498V267.77L164.326 243.39V262.116Z",
    fill: "url(#paint6_linear_2133_425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.553 266.832L247.968 242.92L248.78 243.39L206.553 267.77L164.326 243.39L165.138 242.922L206.553 266.832Z",
    fill: "#163C77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.685 271.09L239.189 256.782L259.831 273.312L261.579 287.58V300.586L351.122 354.665L371.507 366.7L368.4 376.02L354.229 381.649L341.742 379.97L292.155 348.925L248.78 324.854L236.633 315.535L235.857 295.734L234.303 283.697L214.685 271.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.191 384.932C357.217 384.932 361.245 383.872 364.915 381.753C372.256 377.515 376.64 369.923 376.64 361.446V295.517C376.64 293.748 375.206 292.314 373.437 292.314C371.668 292.314 370.234 293.748 370.234 295.517V361.446C370.234 367.606 367.048 373.125 361.712 376.205C356.376 379.286 350.005 379.286 344.669 376.205L245.448 318.879C241.722 316.728 239.408 312.719 239.408 308.416V293.744C239.408 287.159 235.865 281.025 230.164 277.733L218.245 270.851C216.712 269.966 214.755 270.491 213.869 272.022C212.984 273.555 213.509 275.512 215.042 276.397L226.961 283.279C230.687 285.43 233.001 289.44 233.001 293.742V308.414C233.001 314.999 236.544 321.133 242.245 324.425L341.466 381.752C345.137 383.872 349.165 384.932 353.191 384.932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.004 257.958C238.888 256.427 240.846 255.9 242.38 256.786L254.299 263.669C260 266.961 263.543 273.096 263.543 279.68V294.352C263.543 298.655 265.857 302.664 269.584 304.815L373.403 364.796C375.596 366.062 377.964 366.799 380.362 367.024C380.141 369.143 380.222 371.302 380.047 373.437C376.654 373.159 373.3 372.133 370.2 370.344L266.381 310.363C260.679 307.071 257.137 300.936 257.137 294.352V279.68C257.137 275.377 254.823 271.368 251.096 269.217L239.177 262.334C237.644 261.448 237.119 259.491 238.004 257.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.42 383.009L372.16 370.826L373.544 356.412V321.468L373.447 308.482L398.968 312.823V300.952C398.968 299.183 400.402 297.748 402.171 297.748C403.94 297.748 405.374 299.183 405.374 300.952V350.035C405.374 358.513 400.992 366.104 393.649 370.343C392.327 371.106 390.958 371.726 389.561 372.214L389.552 372.224L362.42 383.009Z",
    fill: "url(#paint7_linear_2133_425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.191 384.932C357.217 384.932 361.245 383.872 364.915 381.753C372.256 377.515 376.64 369.923 376.64 361.446V295.517C376.64 293.748 375.206 292.314 373.437 292.314C371.668 292.314 370.234 293.748 370.234 295.517V361.446C370.234 367.606 367.048 373.125 361.712 376.205C356.376 379.286 350.005 379.286 344.669 376.205L245.448 318.879C241.722 316.728 239.408 312.719 239.408 308.416V293.744C239.408 287.159 235.865 281.025 230.164 277.733L218.245 270.851C216.712 269.966 214.755 270.491 213.869 272.022C212.984 273.555 213.509 275.512 215.042 276.397L226.961 283.279C230.687 285.43 233.001 289.44 233.001 293.742V308.414C233.001 314.999 236.544 321.133 242.245 324.425L341.466 381.752C345.137 383.872 349.165 384.932 353.191 384.932Z",
    fill: "url(#paint8_linear_2133_425)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M197.641 277.515L201.951 280.004V271.347L197.641 268.857V277.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M190.462 273.37L194.772 275.859V267.202L190.462 264.713V273.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M183.284 269.226L187.594 271.715V263.058L183.284 260.569V269.226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.104 265.081L180.415 267.571V258.913L176.104 256.424V265.081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.926 260.937L173.237 263.426V254.769L168.926 252.28V260.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.419 247.158L316.648 222.777V204.051L274.419 228.431V247.158Z",
    fill: "url(#paint9_linear_2133_425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.42 228.431L316.648 204.051L274.421 179.672L232.194 204.051L274.42 228.431Z",
    fill: "url(#paint10_linear_2133_425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.192 222.777L274.421 247.158V228.431L232.192 204.051V222.777Z",
    fill: "url(#paint11_linear_2133_425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.42 227.493L315.836 203.582L316.648 204.051L274.42 228.431L232.194 204.051L233.005 203.583L274.42 227.493Z",
    fill: "#163C77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.552 231.751L307.057 217.443L327.7 233.973L329.446 248.241V261.247L418.989 315.326L439.373 327.363L436.267 336.681L422.095 342.31L402.488 336.486L352.901 305.44L316.648 285.515L304.501 276.196L303.724 256.395L302.171 244.358L282.552 231.751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.059 345.593C425.085 345.593 429.113 344.533 432.783 342.414C440.125 338.176 444.508 330.584 444.508 322.107V256.177C444.508 254.408 443.074 252.974 441.305 252.974C439.536 252.974 438.102 254.408 438.102 256.177V322.107C438.102 328.267 434.916 333.786 429.58 336.866C424.244 339.947 417.873 339.947 412.537 336.866L313.317 279.54C309.59 277.389 307.276 273.379 307.276 269.077V254.405C307.276 247.82 303.733 241.686 298.032 238.394L286.113 231.511C284.581 230.627 282.623 231.152 281.737 232.683C280.852 234.215 281.377 236.173 282.91 237.058L294.829 243.94C298.555 246.091 300.87 250.101 300.87 254.403V269.075C300.87 275.66 304.412 281.794 310.113 285.086L409.334 342.413C413.005 344.533 417.032 345.593 421.059 345.593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.87 218.619C306.755 217.088 308.713 216.562 310.247 217.448L322.165 224.33C327.867 227.622 331.409 233.756 331.409 240.341V255.013C331.409 259.316 333.723 263.325 337.45 265.476L441.27 325.457C443.462 326.723 445.83 327.46 448.229 327.685C448.007 329.804 448.089 331.963 447.914 334.098C444.52 333.82 441.167 332.794 438.066 331.005L334.247 271.024C328.546 267.732 325.003 261.597 325.003 255.013V240.341C325.003 236.038 322.689 232.029 318.962 229.878L307.043 222.995C305.511 222.109 304.987 220.152 305.87 218.619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.059 345.593C425.085 345.593 429.113 344.533 432.783 342.414C440.125 338.176 444.508 330.584 444.508 322.107V256.177C444.508 254.408 443.074 252.974 441.305 252.974C439.536 252.974 438.102 254.408 438.102 256.177V322.107C438.102 328.267 434.916 333.786 429.58 336.866C424.244 339.947 417.873 339.947 412.537 336.866L313.317 279.54C309.59 277.389 307.276 273.379 307.276 269.077V254.405C307.276 247.82 303.733 241.686 298.032 238.394L286.113 231.511C284.581 230.627 282.623 231.152 281.737 232.683C280.852 234.215 281.377 236.173 282.91 237.058L294.829 243.94C298.555 246.091 300.87 250.101 300.87 254.403V269.075C300.87 275.66 304.412 281.794 310.113 285.086L409.334 342.413C413.005 344.533 417.032 345.593 421.059 345.593Z",
    fill: "url(#paint12_linear_2133_425)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M265.509 238.177L269.82 240.665V232.007L265.509 229.52V238.177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M258.33 234.031L262.64 236.52V227.863L258.33 225.374V234.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.152 229.887L255.462 232.376V223.718L251.152 221.229V229.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.973 225.742L248.283 228.232V219.574L243.973 217.085V225.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.794 221.598L241.105 224.087V215.43L236.794 212.941V221.598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.287 207.819L384.514 183.438V164.712L342.287 189.092V207.819Z",
    fill: "url(#paint13_linear_2133_425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.287 189.092L384.514 164.712L342.288 140.333L300.06 164.712L342.287 189.092Z",
    fill: "url(#paint14_linear_2133_425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.06 183.438L342.287 207.819V189.092L300.06 164.712V183.438Z",
    fill: "url(#paint15_linear_2133_425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.287 188.154L383.702 164.243L384.514 164.712L342.287 189.092L300.06 164.712L300.872 164.244L342.287 188.154Z",
    fill: "#163C77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.419 192.412L374.923 178.104L395.565 194.634L397.313 208.902V221.908L486.856 275.987L507.241 288.022L504.134 297.342L489.963 302.971L470.355 297.148L420.768 266.101L384.514 246.174L372.366 236.857L371.591 217.056L370.037 205.019L350.419 192.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.925 306.254C492.951 306.254 496.979 305.194 500.649 303.075C507.99 298.837 512.374 291.245 512.374 282.768V216.839C512.374 215.07 510.94 213.636 509.171 213.636C507.402 213.636 505.968 215.07 505.968 216.839V282.768C505.968 288.928 502.782 294.447 497.446 297.527C492.11 300.608 485.739 300.608 480.403 297.527L381.182 240.201C377.456 238.05 375.141 234.04 375.141 229.738V215.066C375.141 208.481 371.599 202.347 365.898 199.055L353.979 192.172C352.446 191.288 350.488 191.813 349.602 193.344C348.718 194.876 349.243 196.834 350.776 197.719L362.694 204.601C366.421 206.752 368.735 210.762 368.735 215.064V229.736C368.735 236.321 372.278 242.455 377.979 245.747L477.2 303.074C480.871 305.194 484.899 306.254 488.925 306.254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.738 179.28C374.622 177.749 376.58 177.223 378.114 178.109L390.033 184.991C395.734 188.283 399.277 194.417 399.277 201.002V215.674C399.277 219.977 401.592 223.986 405.318 226.137L509.137 286.118C511.33 287.384 513.697 288.121 516.096 288.346C515.875 290.465 515.956 292.624 515.781 294.759C512.388 294.481 509.034 293.455 505.934 291.666L402.114 231.685C396.413 228.393 392.871 222.258 392.871 215.674V201.002C392.871 196.699 390.556 192.69 386.83 190.539L374.911 183.656C373.378 182.77 372.853 180.813 373.738 179.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.925 306.254C492.951 306.254 496.979 305.194 500.649 303.075C507.99 298.837 512.374 291.245 512.374 282.768V216.839C512.374 215.07 510.94 213.636 509.171 213.636C507.402 213.636 505.968 215.07 505.968 216.839V282.768C505.968 288.928 502.782 294.447 497.446 297.527C492.11 300.608 485.739 300.608 480.403 297.527L381.182 240.201C377.456 238.05 375.141 234.04 375.141 229.738V215.066C375.141 208.481 371.599 202.347 365.898 199.055L353.979 192.172C352.446 191.288 350.488 191.813 349.602 193.344C348.718 194.876 349.243 196.834 350.776 197.719L362.694 204.601C366.421 206.752 368.735 210.762 368.735 215.064V229.736C368.735 236.321 372.278 242.455 377.979 245.747L477.2 303.074C480.871 305.194 484.899 306.254 488.925 306.254Z",
    fill: "url(#paint16_linear_2133_425)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M333.376 198.838L337.687 201.326V192.668L333.376 190.181V198.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.197 194.692L330.507 197.182V188.524L326.197 186.035V194.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.019 190.548L323.329 193.037V184.38L319.019 181.891V190.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.838 186.403L316.149 188.893V180.235L311.838 177.746V186.403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.66 182.259L308.972 184.748V176.091L304.66 173.602V182.259Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2133_425",
    x: 0,
    y: 0,
    width: 471,
    height: 378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2133_425"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2133_425",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2133_425",
    x1: 91.3202,
    y1: 180.826,
    x2: 357.357,
    y2: 180.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#163C77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2133_425",
    x1: 136.184,
    y1: 241.66,
    x2: 367.631,
    y2: 241.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180D5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2133_425",
    x1: 458.102,
    y1: 304.923,
    x2: 167.571,
    y2: 172.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#1A1660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2466,
    stopColor: "#1E2D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#255385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6555,
    stopColor: "#2F87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8978,
    stopColor: "#3CCACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E8E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2133_425",
    x1: 372.415,
    y1: 143.174,
    x2: 325.591,
    y2: 104.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#1A1660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2466,
    stopColor: "#1E2D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#255385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6555,
    stopColor: "#2F87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8978,
    stopColor: "#3CCACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E8E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2133_425",
    x1: 252.503,
    y1: 247.821,
    x2: 199.517,
    y2: 284.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2573BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2133_425",
    x1: 238.212,
    y1: 229.789,
    x2: 178.592,
    y2: 255.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#163C77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2133_425",
    x1: 211.964,
    y1: 256.947,
    x2: 155.407,
    y2: 273.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2133_425",
    x1: 427.892,
    y1: 340.379,
    x2: 356.166,
    y2: 340.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2573BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2133_425",
    x1: 376.641,
    y1: 327.677,
    x2: 213.439,
    y2: 327.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2133_425",
    x1: 320.37,
    y1: 208.482,
    x2: 267.385,
    y2: 245.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2573BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2133_425",
    x1: 306.079,
    y1: 190.45,
    x2: 246.459,
    y2: 216.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#163C77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2133_425",
    x1: 279.831,
    y1: 217.608,
    x2: 223.274,
    y2: 234.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2133_425",
    x1: 444.508,
    y1: 288.338,
    x2: 281.307,
    y2: 288.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2133_425",
    x1: 388.237,
    y1: 169.143,
    x2: 335.252,
    y2: 205.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2573BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2133_425",
    x1: 373.946,
    y1: 151.111,
    x2: 314.326,
    y2: 176.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#163C77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2133_425",
    x1: 347.698,
    y1: 178.269,
    x2: 291.141,
    y2: 195.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2133_425",
    x1: 512.375,
    y1: 248.999,
    x2: 349.174,
    y2: 248.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartWire);
export default __webpack_public_path__ + "static/media/smart-wire.313114110611b24bd14f2bde4935724b.svg";
export { ForwardRef as ReactComponent };